import React, { useContext, useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  createNewAppointment,
  useDefultAppointmentReminder,
} from "repositories/patient-appointment-repository";
import { decodeId, encodeId, getStorage } from "utils";
import constants from "../../../../constants";
import {
  useAllPatient,
  useDoctorOffices,
} from "repositories/doctor-repository";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  useOfficeDetail,
  useStaffByUserId,
} from "repositories/office-repository";
import { AppointmentsContext } from "../AppointmentsContext";
import { useQueryClient } from "react-query";
import { useUser } from "repositories/user-repository";

const useCreatePatientAppointmentModule = (keyName) => {
  const profile = useSelector((state) => state.userProfile.profile);
  const [repeatOptions, setRepeatOptions] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [searchTerm, setSearchterm] = useState("");
  const [selectedOfficeData, setSelectedOfficeData] = useState("");
  const history = useHistory();
  const location = useLocation();
  let { officeId, patientId } = useParams();
  officeId = decodeId(officeId);
  patientId = patientId ? decodeId(patientId) : null;
  const [errors, setErrors] = useState({});
  const isFromManagePage = getStorage("isFromManagePage");
  const seeTodaySchedule = getStorage("see-today-schedule");
  const queryClient = useQueryClient();
  const { data: DoctorOfficeData, isLoading: doctorOfficeLoading } =
    useDoctorOffices(profile?.id, 1, 100);

  const { data: patientDetail } = useUser(patientId, {
    enabled: !!patientId,
  });

  const { data: patientData, isLoading: patientDataLoading } = useAllPatient(
    1,
    100,
    searchTerm
  );

  const { isLoading: officeLoading, data: OfficeData } = useOfficeDetail(
    officeId,
    { enabled: !!officeId }
  );

  const {
    reminderPlan,
    setReminderPlan,
    selectedPatient,
    setSelectedPatient,
    selectedOffice,
    selectedDoctor,
  } = useContext(AppointmentsContext);

  const { data: staffDetail } = useStaffByUserId(officeId, profile?.id);
  let IsForRecall = false;
  const {
    isLoading: defaultAppointmentLoading,
    refetch: defaultAppointmentFetch,
  } = useDefultAppointmentReminder(
    selectedOffice,
    selectedPatient?.id,
    IsForRecall,
    {
      enabled: !!(selectedOffice && selectedPatient?.id),
    }
  );

  useEffect(() => {
    const options = DoctorOfficeData?.items?.map((item) => ({
      id: item.id,
      name: item?.name,
    }));
    setRepeatOptions(options);
  }, [DoctorOfficeData]);

  useEffect(() => {
    if (patientDetail?.data && patientId) {
      const fullName = `${patientDetail?.data?.firstName || ""} ${
        patientDetail?.data?.lastName || ""
      }`.trim();
      setSelectedPatient({
        name: fullName,
        id: patientDetail?.data?.id,
        email: patientDetail?.data?.emailId,
      });
    }
  }, [patientDetail, patientId, setSelectedPatient]);

  const goToPreviousScreen = () => {
    if (window.history.length) {
      history.goBack();
    } else if (location?.state?.isfromPatientListing) {
      history.push(
        constants.routes.appointment.patients.replace(
          ":officeId",
          encodeId(officeId)
        )
      );
    } else if (isFromManagePage?.isFromManagePage) {
      history.push(
        constants.routes.appointment.officeSelection.replace(
          ":officeId",
          encodeId(officeId)
        )
      );
    } else if (seeTodaySchedule) {
      history.push(constants.routes.appointment.seeTodaySchedule);
    } else {
      history.push(constants.routes.appointment.appointmentScreen);
    }
  };

  const isValidEvent = (params) => {
    const errorsData = { ...errors };

    if (params?.officeId === 1) {
      errorsData.OfficeError = "Please Select Office";
    } else {
      delete errorsData.OfficeError;
    }

    if (!params?.patientId) {
      errorsData.patientError = "Please Select patient";
    } else {
      delete errorsData.patientError;
    }

    if (!params?.Description?.length > 0) {
      errorsData.desCriptionError = "Please Enter Description";
    } else {
      delete errorsData.desCriptionError;
    }

    if (!params?.appointmentTypeId) {
      errorsData.appointmentTypeError = "Please Enter Appointment Type";
    } else {
      delete errorsData.appointmentTypeError;
    }

    setErrors(errorsData);

    return !Object.values(errorsData).some(Boolean);
  };

  const fetchDefaultData = async () => {
    queryClient.invalidateQueries([
      "/AppointmentReminder/Default",
      selectedOfficeData?.id,
      selectedPatient?.id,
      IsForRecall,
    ]);
    const refetchData = await defaultAppointmentFetch();
    if (refetchData?.data?.appointmentReminderPlanSetting?.length) {
      setReminderPlan((prevReminderPlan) => ({
        ...prevReminderPlan,
        [keyName]: {
          title: refetchData?.data?.title,
          id: refetchData?.data?.id,
          appointmentReminderPlanSetting: [
            ...refetchData?.data?.appointmentReminderPlanSetting,
          ],
        },
      }));
    }
  };

  useEffect(() => {
    if (selectedOffice && selectedPatient?.id) {
      if (!reminderPlan?.[keyName] && !isLoading) {
        fetchDefaultData();
      }
    }
  }, [
    defaultAppointmentLoading,
    defaultAppointmentFetch,
    selectedPatient,
    selectedOffice,
  ]);

  const handleSubmit = async (e, params) => {
    e.preventDefault();
    if (isValidEvent(params)) {
      setShowLoader(true);
      try {
        let res = await createNewAppointment(params);
        if (res?.statusCode === 200) {
          goToPreviousScreen();
          toast.success(res.message);
        }
      } catch (err) {
        setShowLoader(true);
        toast.error(err.message);
      } finally {
        setShowLoader(false);
      }
    }
  };
  let isLoading =
    doctorOfficeLoading ||
    showLoader ||
    patientDataLoading ||
    officeLoading ||
    defaultAppointmentLoading;

  let selecteddoctorID =
    selectedDoctor?.id
      ? selectedDoctor?.id
      : profile?.id;

  return {
    data: {
      isFromManagePage,
      DoctorOfficeData,
      repeatOptions,
      isLoading,
      searchTerm,
      patientData,
      OfficeData,
      errors,
      selectedOfficeData,
      selecteddoctorID,
      patientDetail,
    },
    methods: {
      goToPreviousScreen,
      handleSubmit,
      setSearchterm,
      setSelectedOfficeData,
    },
  };
};

export default useCreatePatientAppointmentModule;
